import { Grid, Typography} from '@mui/material'
import colors from '../../../colors'
import React from 'react'
import { makeStyles } from '@mui/styles';
import { texts } from '../../../general/texts'

export const TopUpBankPending = () => {

    const useStyles = makeStyles({
        header:{
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            color:colors.darkBlue,
            textAlign:'left'
        },
        text:{
            fontSize:'0.9rem',
            fontFamily:'GerberaMedium',
            color:colors.darkBlue,
            textAlign:'left'
        }
    })

    const classes = useStyles()

    return (
        <Grid container item md={12} spacing={3}>
            <Grid container item md={12} alignItems='flex-start' direction='column' >
                <Grid item><Typography className={classes.header} >{texts["message-bank-link-pending-title"]}</Typography> </Grid>
            </Grid>
            <Grid container item md={12} alignItems='flex-start' direction='column' >
                <Grid item><Typography  className={classes.text}>{texts["message-bank-link-pending"]}</Typography> </Grid>
            </Grid>
        </Grid>
    )
}
export default TopUpBankPending
